var _circle, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFaqs13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 61,
    stroke: "#339999",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.4297 74.5584L64.6363 79.638C65.1491 80.1383 65.7579 80.5351 66.4279 80.8059C67.0979 81.0766 67.816 81.216 68.5412 81.216C69.2664 81.216 69.9845 81.0766 70.6546 80.8059C71.3246 80.5351 71.9334 80.1383 72.4462 79.638C72.959 79.1377 73.3657 78.5437 73.6433 77.8901C73.9208 77.2364 74.0636 76.5358 74.0636 75.8283C74.0636 75.1207 73.9208 74.4201 73.6433 73.7665C73.3657 73.1128 72.959 72.5189 72.4462 72.0186",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2396 66.9391L73.7478 73.2886C74.7835 74.299 76.1881 74.8666 77.6528 74.8666C79.1174 74.8666 80.522 74.299 81.5577 73.2886C82.5934 72.2782 83.1752 70.9078 83.1752 69.4789C83.1752 68.05 82.5934 66.6796 81.5577 65.6692L71.4569 55.8148C69.9926 54.3879 68.0076 53.5864 65.9379 53.5864C63.8683 53.5864 61.8833 54.3879 60.4189 55.8148L58.128 58.0498C57.0924 59.0602 55.6877 59.6278 54.2231 59.6278C52.7585 59.6278 51.3538 59.0602 50.3182 58.0498C49.2825 57.0394 48.7007 55.669 48.7007 54.2401C48.7007 52.8112 49.2825 51.4408 50.3182 50.4304L57.6334 43.2935C60.0083 40.9827 63.1053 39.5106 66.4342 39.1104C69.7632 38.7102 73.1339 39.4047 76.0127 41.0839L77.2362 41.7951C78.3447 42.4478 79.6626 42.6741 80.9329 42.43L85.4626 41.5411",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4627 39.0012L88.066 66.939H82.8594",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6033 39.0012L36 66.939L52.9214 83.4477C53.9571 84.4581 55.3617 85.0258 56.8264 85.0258C58.291 85.0258 59.6956 84.4581 60.7313 83.4477C61.767 82.4373 62.3488 81.0669 62.3488 79.638C62.3488 78.2091 61.767 76.8387 60.7313 75.8283",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6034 41.541H59.4298",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaqs13);
export default __webpack_public_path__ + "static/media/IconFaqs13.b9e8477cc12591c231ec76171a8f5e55.svg";
export { ForwardRef as ReactComponent };